if (!customElements.get('er-quick-add')) {
  class ErQuickAdd extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('.er-quick-add__btn');
      if (this.button && !this.button.disabled) {
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          this.handleAddToCart();
        });
      }
    }

    async handleAddToCart() {
      const variantId = this.button.getAttribute('data-variant-id');
      this.showLoadingState(true);
      try {
        await this.addToCart(variantId, 1);
      } finally {
        this.showLoadingState(false);
      }
    }

    async addToCart(variantId, quantity) {
      try {
        const isPreorder = this.dataset.isPreorder === 'true';
        const bodyData = isPreorder
          ? { id: variantId, quantity, properties: { PreOrder: 'PreOrder' } }
          : { id: variantId, quantity };

        await CartUtils.addToCartAndOpen(bodyData);
      } catch (error) {
        console.error('Error adding item to cart:', error);
      }
    }

    showLoadingState(isLoading) {
      const loadingIconUrl = this.getAttribute('data-loading-icon');
      if (isLoading) {
        this.button.dataset.originalContent = this.button.dataset.originalContent || this.button.innerHTML;
        this.button.innerHTML = `<img src="${loadingIconUrl}" alt="Loading..." class="loading-spinner" />`;
        this.button.disabled = true;
      } else {
        this.button.innerHTML = this.button.dataset.originalContent;
        this.button.disabled = false;
      }
    }
  }

  customElements.define('er-quick-add', ErQuickAdd);
}
